export interface ClientData {
  Profile: Profile;
  PurchasePower: PurchasePower;
  Portfolio: ClientDataPortfolio;
}

export interface ClientDataPortfolio {
  EGPPortfolio: Portfolio;
  USDPortfolio: Portfolio;
  RatedPortfolio: Portfolio;
}

export interface Portfolio {
  Portfolio: PortfolioElement[];
  TotalCostValue: number;
  TotalMarketValue: number;
  TotalMarginMarketValue: number;
  TotalGL: number;
  TotalGLPer: number | null;
}

export interface PortfolioElement {
  SymbolCode: string;
  CustodianCode: number;
  Qty: number;
  SetteledQty: number;
  NormalQty: number;
  AvbSetteledQty : any;
  AvbTPlusOneQty;
  AvbTPlusZeroQty;
  BlkSetteledQty;
  BlkTPlusOneQty;
  BlkTPlusZeroQty;
  TPlusFiveQty;
  TPlusFourQty;
  TPlusOneQty;
  TPlusThreeQty;
  TPlusZeroQty;
  Salable: number;
  AvgCost: number;
  MarketPrice: number;
  CostValue: number;
  MarketValue: number;
  GL: number;
  GLPerc: number;
  CreateDate: null;
  LastUpdateDate: null;
  SymbolNameEn: null | string;
  SymbolNameAr: null | string;
  CustodianNameE: CustodianName;
  CustodianNameA: CustodianName;
  ReutersCode: string;
  Curr: Curr;
  CurrencyID: number;
  Weight: number;
  IsSuspended: boolean;
  MarketCode: any;
  // MarginMarketValue: number;
}

export enum Curr {
  EGP = "EGP",
}

export enum CustodianName {
  جراندالقابضةللاستثماراتالمالية = "جراند القابضة للاستثمارات المالية",
}

export interface Profile {
  RelationCode: string;
  ExchangeCode: string;
  UnifiedCode: string;
  SubNameE: string;
  SubNameA: string;
  UserName: null;
  Phone: string;
  MobileNumbers?: string[];
  Email: string;
  IdNumber: string;
  Address: string;
  AccountManagerNameE: string;
  AccountManagerNameA: string;
  BranchNameA: string;
  BranchNameE: string;
  CompanyNameAr: string;
  CompanyNameEn: string;
  IsMargin: boolean;
  RelationShipNameEn: string;
  RelationShipNameAr: string;
  OpenOrderRestriction:boolean;
}

export interface PurchasePower {
  purchasePower: PurchasePowerClass;
  BlockingAmount: BlockingAmount[];
}

export interface BlockingAmount {
  curr: string;
  bookbalance: number;
  activebalance: number;
  availablebalance: number;
  blkAmt: number;
  withHeldAmt: number;
  MarginCustodian: number;
  netAsset: number;
  crdLmt: number;
  penSell: number;
  mrgLmt: number;
  dayCashMar: number;
  pendBuy: number;
  penSellCommission: number;
}

export interface PurchasePowerClass {
  EGP: number;
  USD: number;
  Rated: number;
}

export interface Account {
  accountType: number;
  accountTypeEn: string;
  accountTypeAr: string;
  clientNameAr: string;
  clientNameEn: string;
  relationCode: string;
  ExchangeCode: string;
  Isdormint: boolean;
  IsMargin: boolean;
  mainCode?:number;
  subCode?:number;
}
export enum StatementEnum {
  MainClient = 0,
  SubClient = 1,
  Account = 2,
  Bank = 3,
  Custodian = 4,
  AccountTrialBalance = 5,
  MainTrialBalance = 6,
  SubTrialBalance = 7,
  BankTrialBalance = 8,
  CustodianTrialBalance = 9,
  ClientMovment = 10,
  Broker = 11,
  BrokerTrialBalance = 12,
  Client = 13
}